import React from "react";
import SystemStatus from "./SystemStatus";
import ProctorInstructions from "./ProctorInstructions";

const WelcomeScreen = ({
  channelName,
  isChecking,
  hasCamera,
  hasMicrophone,
  deviceError,
  checkDevices,
  startProctoring,
}) => {
  return (
    <div className="main-content">
      <header className="header">
        <div className="header-main">
          <h1>Proctor Console</h1>
          <div className="session-badge">
            <span className="session-id">ID: {channelName}</span>
          </div>
        </div>
      </header>

      <div className="welcome-container">
        <div className="panel system-status">
          <div className="panel-header">
            <div className="session-role">Proctor</div>
          </div>

          <div className="system-status-content">
            <SystemStatus
              isChecking={isChecking}
              hasCamera={hasCamera}
              hasMicrophone={hasMicrophone}
              deviceError={deviceError}
              checkDevices={checkDevices}
            />
            <ProctorInstructions />
          </div>

          <div className="action-container">
            <div className="button-wrapper">
              <button
                className="start-button"
                onClick={startProctoring}
                disabled={!hasCamera || !hasMicrophone}
              >
                Start Verification
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
